<template>
  <div style="height: 100%;width:1440px;">
    <div align="center">
      <table width="60%" align="center">
        <tr>
          <td align="right" width="25%"><font
            style="color: #004499; font-size: 20px;"> Operation Schedule:</font></td>
          <td align="left" width="25%"><font
            style="color: #8A2BE2; font-size: 20px;">{{status.operationMode}}</font></td>
          <td align="right" width="25%"><font
            style="color: #004499; font-size: 20px;"> Operation Status:</font></td>
          <td align="left" width="25%"><font
            style="color: #8A2BE2; font-size: 20px;">{{status.operationStatus}}</font></td>
        </tr>
        <tr>
          <td align="right" width="25%"><font
            style="color: #004499; font-size: 20px;"> Beam Current:</font></td>
          <td align="left" width="25%"><font
            style="color: #8A2BE2; font-size: 20px;">{{status.beamCurrent}}</font></td>
          <td align="right" width="25%"><font
            style="color: #004499; font-size: 20px;"> Lifetime:</font></td>
          <td align="left" width="25%"><font
            style="color: #8A2BE2; font-size: 20px;">{{status.lifetime}}</font></td>
        </tr>
        <tr>
          <td align="right" width="25%"><font
            style="color: #004499; font-size: 20px;"> Energy:</font></td>
          <td align="left" width="25%"><font
            style="color: #8A2BE2; font-size: 20px;">{{status.energy}}</font></td>
        </tr>
      </table>
    </div>
    <div align="center" style="margin-top:20px;">
      <highcharts :options='options' style="width: 70%"></highcharts>
      <div align="left" style="width:50%;">
        <el-switch
          active-color="#0055fa"
          inactive-color="#696969"
          active-text="Lifetime"
          v-model="switchValue1"
          @change="addLifeTime">
        </el-switch>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "home",
    data() {
      return {

        switchValue1: false,

        ws: null,

        status: {
          operationMode: "",
          beamCurrent: "",
          lifetime: "",
          operationStatus: "",
          energy: "",
        },

        options: {
          chart: {
            backgroundColor: '#eef3f7',
            width: 1000,
            height: 400,
            zoomType: null,
            enabled: false,
            plotBorderWidth: 2,
            plotBorderColor: 'grey',
            animation: false           //关闭渲染动画
          },
          plotOptions: {

            series: {
              turboThreshold: 10000,   //最大渲染点数
              animation: false,       //关闭渲染动画
            },
            line: {
              dataGrouping: {
                enabled: false        //关闭数据分组显示，确保页面显示所有数据
              }
            }
          },
          title: {
            text: null
          },
          xAxis: {
            gridLineDashStyle: 'ShortDash',
            gridLineWidth: 1,
            lineColor: 'grey',
            ordinal: false,
            type: 'datetime',
            title: {
              text: 'Time',
              style: {
                color: "black",
                fontWeight: 1000,
              }
            },
            dateTimeLabelFormats: {
              millisecond: '%H:%M:%S.%L',
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%m-%d %H:%M',
              day: '%m-%d %H:%M',
              week: '%m-%d %H:%M',
              month: '%Y-%m-%d %H:%M',
              year: '%Y'
            },
            tickInterval: 4 * 60 * 60 * 1000,
            // endOnTick:true,
            max: new Date().getTime(),
            min: new Date(Date.now() - 24 * 1000 * 60 * 60).getTime()
          },
          yAxis: [{
            // gridLineDashStyle:'ShortDash',
            gridLineWidth: 0,
            lineColor: 'grey',
            showFirstLabel: true,    //显示坐标轴第一个点
            showLastLabel: true,      //显示最后一个点
            opposite: false,             //坐标轴位置
            type: 'linear',
            title: {
              text: 'Beam Current(mA)',
              style: {
                color: "black",
                fontWeight: 1000
              }
            },
            lineWidth: 2,
            // tickPositioner: function () {
            //   console.log(this.tickPositions)
            //   let n = this.tickPositions.length;
            //   if(Math.abs(this.tickPositions[0]-this.tickPositions[n-1])>=150){
            //     let p = this.tickPositions[n-1];
            //     let interval = Math.ceil(Math.ceil(p / 5)/10)*10
            //     return [0, interval, 2 * interval, 3 * interval, 4 * interval,5*interval];
            //   } else if(this.tickPositions[0] > 190 && this.tickPositions[n-1] < 370) {
            //     return [180, 220, 260, 300, 340, 380]
            //   } else if (this.tickPositions[0] < 190 && this.tickPositions[n-1] < 400 && Math.abs(this.tickPositions[0]-this.tickPositions[n-1])>=100) {
            //     return [0, 80, 160, 240, 320, 400]
            //   }else if(this.tickPositions[0] < 1){
            //     let p = new Array();
            //     if(n < 6){return this.tickPositions;  }
            //     for (let i = 0; i < 6; i++){
            //       console.log(parseFloat(this.tickPositions[i]).toFixed(4))
            //       // console.log(Highcharts.numberFormat(1.2345,2))
            //       p.push(parseFloat(this.tickPositions[i]))
            //     }
            //     return p;
            //   }else {
            //     return this.tickPositions;
            //   }
            // }
            startOnTick: false,
            min: 0,
            // max:350
          },
            {
              gridLineWidth: 0,
              lineColor: 'grey',
              showFirstLabel: true,
              showLastLabel: true,
              opposite: true,
              type: 'linear',
              title: {
                text: 'Lifetime(hours)',
                style: {
                  color: "black",
                  fontWeight: 1000
                }
              },
              startOnTick: false,
              lineWidth: 2,

            }],
          tooltip: {
            dateTimeLabelFormats: {
              millisecond: '%m-%d %H:%M:%S.%L',
              second: '%m-%d %H:%M:%S',
              minute: '%m-%d %H:%M',
              hour: '%m-%d %H:%M',
              day: '%Y-%m-%d %H:%M',
              week: '%m-%d',
              month: '%Y-%m',
              year: '%Y'
            }
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
            itemMarginTop: 20,
            verticalAlign: 'bottom',
            // layout: 'vertical',
            align: 'middle'
          },
          navigator: {
            // adaptToUpdatedData: false,
            enabled: false
          },
          exporting:{
            enabled:false
          },
          series: [{
            name: 'Beam Current',
            data: [],
            yAxis: 0,
            lineWidth: 1.5,
            color: "#0055fa",
            showInLegend: false,
            showLegends: false,
          }, {
            name: 'LifeTime',
            data: [],
            yAxis: 1,
            lineWidth: 1.5,
            color: "#FF0000",
            visible: false,
            showInLegend: false,
          }]
        },
        timer: null
      }
    },
    created(){
      this.initWebpack();
    },
    mounted() {
      if(this.$route.params.dialogVisible){
        this.$root.$children[0].loginClick();
        this.$root.$children[0].dialogVisible = true
      }
      this.options.series[0].data = [];
      this.options.series[1].data = [];
      let p = new Array();
      let date1 = new Date(Date.now())
      let date2 = new Date(Date.now() - 3600 * 24 * 1000)
      let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
      let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
      let _this = this;
      this.options.yAxis[1].title.text = ""
      // this.options.xAxis.tickPositions = [date2.getTime(),new Date(date2+12*1000*3600).getTime(),date1.getTime()]

      this.$axios.get('/hlsTS/beam/status')
        .then(function (response) {
          let n = response.data['Beam']['BeamCurrent'].length;
          let m = response.data['Beam']['LifeTime'].length;
          let a = [];
          let b = [];
          for (let i = 0; i < n; i++) {
            a.push([new Date(response.data.Beam.BeamCurrent[i].timeStamp.replace(/-/g, '/')).getTime(), response.data.Beam.BeamCurrent[i].value]);
          }
          _this.options.series[0].data = a;
          for (let i = 0; i < m; i++) {
            // if(new Date(response.data.Beam.LifeTime[i].timeStamp.replace(/-/g, '/'))-date2 < 0
            //   || new Date(response.data.Beam.LifeTime[i].timeStamp.replace(/-/g, '/'))-date1 > 0){
            //   break;
            // }
            b.push([new Date(response.data.Beam.LifeTime[i].timeStamp.replace(/-/g, '/')).getTime(), response.data.Beam.LifeTime[i].value]);
          }
          _this.options.series[1].data = b;
        })
      this.timer = setInterval(getIntegralData, 30000);

      function getIntegralData() {
        _this.options.xAxis.max = new Date().getTime()
        _this.options.xAxis.min = new Date(Date.now() - 24 * 1000 * 60 * 60).getTime()
        let p = new Array();
        date1 = new Date(Date.now());
        date2 = new Date(Date.now() - 3600 * 24 * 1000);
        time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        _this.$axios.get('/hlsTS/beam/status')
          .then(function (response) {
            let n = response.data['Beam']['BeamCurrent'].length;
            let m = response.data['Beam']['LifeTime'].length;
            _this.options.series[0].data = [];
            _this.options.series[1].data = [];
            for (let i = 0; i < n; i++) {
              _this.options.series[0].data.push([new Date(response.data.Beam.BeamCurrent[i].timeStamp.replace(/-/g, '/')).getTime(), response.data.Beam.BeamCurrent[i].value]);
            }
            for (let i = 0; i < m; i++) {
              _this.options.series[1].data.push([new Date(response.data.Beam.LifeTime[i].timeStamp.replace(/-/g, '/')).getTime(), response.data.Beam.LifeTime[i].value]);
            }
          })
      }

      this.initWebpack();
      setTimeout(function(){
        _this.initWebpack();
      },1000);
    },
    methods: {
      

      initWebpack: function () {
        let str = window.location.href;
        //let str = 'http://192.168.113.38';
         //let str = 'http://192.168.113.43:8765';
        // str = 'http://192.168.125.222:8090';
        //http://210.45.77.114:8080/home
        // let str = 'http://localhost:8090';
        const wsuri = "ws://" + str.split("/")[2] + "/ws/status";
        // const wsuri = "ws://" + str.split("/")[2] + "/status";
        //const wsuri = "ws://" + str.split("/")[2] + "/status";
        //const wsuri = "ws://"+ '192.168.125.202:8080' + "/status";
        let websock = new WebSocket(wsuri);
        websock.onopen = () => {
          var postValue = {};
          websock.send(JSON.stringify(postValue));
        }
        websock.onmessage = e => {
     
          this.status.energy = null;
          this.status.lifetime = null;
          this.status.beamCurrent = null;
          this.status.operationStatus = null;
          this.status.operationMode = null;
          let data = JSON.parse(e.data)
       
          this.status.beamCurrent = parseFloat(data['Current']).toFixed(2).toString() + " mA";
          if (data['Lifetime'] === 'Infinity') {
              this.status.lifetime = 'inf' + " hours";
            } else {
              this.status.lifetime = parseFloat(data['Lifetime']).toFixed(2).toString() + " hours";
          }
          this.status.energy = parseFloat(data['Energy']).toFixed(2).toString() + " MeV";
          this.status.operationMode = data['OperationMode']
          this.status.operationStatus = data['OperationStatus']
        }
        websock.onclose = function () {
          // 关闭 websocket
        }
        // 路由跳转时结束websocket链接
        this.$router.afterEach(function () {
          websock.close()
        })
        websock.onerror = function () {
          console.log("error occurred")
        }
      },

      addLifeTime: function () {
        if (this.switchValue1 === true) {
          this.options.series[1].visible = true
          this.options.yAxis[1].title.text = "Lifetime(hours)"
        } else {
          this.options.series[1].visible = false
          this.options.yAxis[1].title.text = ""
        }
      },
    },
    destroyed() {
      clearInterval(this.timer);
    }
  }
</script>
<style scoped>
  div {
    margin-left: auto;
    margin-right: auto;
  }
  .block{
    
  }
</style>



// WEBPACK FOOTER //
// src/page/activePublic/home.vue